import i18n from "@/common/i18n";
import { LanguageSelect } from "./LanguageSelect";

export const LanguageSelector = (): JSX.Element => {
  const currentLanguage = i18n.language;

  const handleChange = (lang: string): void => {
    void i18n.changeLanguage(lang);
  };

  return <LanguageSelect value={currentLanguage} onChange={handleChange} />;
};
